import { formatNumber } from "helpers/utils";
import type { DashboardData } from "store/analyticsStore";

/**
 * Format top titles data
 * @param dashboard dashboard analytics data
 */
export const getTopTitleData = (dashboard: DashboardData | undefined) => {
    return (
        dashboard &&
        dashboard.topPerformingTitles
            .map((item) => ({
                ...item,
                amount: formatNumber(+item.amount, { noDigit: true, isCurrency: true }),
                author: "",
            }))
            .slice(0, 5)
    );
};

/**
 * Format top beneficiaries data
 * @param dashboard dashboard analytics data
 */
export const getTopBeneficiarData = (dashboard: DashboardData | undefined) => {
    return (
        dashboard &&
        dashboard.topPerformingBeneficiaries
            .map((item) => ({
                ...item,
                amount: formatNumber(+item.amount / 100, { noDigit: true, isCurrency: true }),
            }))
            .slice(0, 5)
    );
};
